export const GET_HELP = {
  REQUEST: 'GET_HELP_REQUEST',
  SUCCESS: 'GET_HELP_SUCCESS',
  FAILURE: 'GET_HELP_FAILURE',
};

export const SET_FAQ = 'SET_FAQ';
